import { APPLICATION_COMPLETED_STATUSES } from 'app/pages/loanApplication/LoanApplication.constants';
import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

// there will be a separate issue to get rid of deal instance
export const selectDealFromApplication = createSelector(selectLoanApplication, ({ deal }) => deal);

export const selectApplicationIdFromDeal = createSelector(
  selectDealFromApplication,
  ({ applicationId }) => applicationId,
);

export const selectApplicationStatusFromDeal = createSelector(
  selectDealFromApplication,
  ({ applicationStatus }) => applicationStatus,
);

export const selectIsApplicationNotCompleted = createSelector(
  selectApplicationStatusFromDeal,
  applicationStatus => !APPLICATION_COMPLETED_STATUSES.includes(applicationStatus),
);

export const selectLoanIdFromDeal = createSelector(
  selectDealFromApplication,
  ({ loanId } = {}) => loanId ?? null,
);
